<!--
 * @Author: zxf
 * @Date: 2022-08-05 19:05:06
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:32:58
 * @Description: 建筑物信息更新
-->

<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="建筑名称（栋）"
            prop="jzwmc"
          >
            <el-input
              v-model="fd.jzwmc"
              class="c-form__input"
              type="text"
              placeholder="请输入建筑名称（栋）"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="面积（m²）"
            prop="mj"
          >
            <el-input
              v-model="fd.mj"
              class="c-form__input"
              type="text"
              placeholder="请输入面积"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="高度（m）"
            prop="gd"
          >
            <el-input
              v-model="fd.gd"
              class="c-form__input"
              type="text"
              placeholder="请输入高度"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="地上层层数"
            prop="dscs"
          >
            <el-input
              v-model="fd.dscs"
              class="c-form__input"
              type="text"
              placeholder="请输入地上层层数"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="地下层数"
            prop="dxcs"
          >
            <el-input
              v-model="fd.dxcs"
              class="c-form__input"
              type="text"
              placeholder="请输入地下层数"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>

import { jzwService } from './jzw.service';
export default {
  name: 'JcjzwUpdateDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      },
      xmId: {
        type: String,
        required: true
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示
      editShow: false, // 编辑模式显示

      /* 表单参数 Start */
      fd: {
        jzwId: null,
        xmId: null,
        jzwmc: null, // 建筑名称（栋）
        mj: null, // 面积（m²）
        gd: null, // 高度（m）
        dxcs: null, // 地下层层数
        dscs: null // 地上层层数
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        jzwmc: [
          this.$validUtils.required('建筑名称（栋）'),
          this.$HMValidator.maxLength('建筑名称（栋）', 300)
        ],
        mj: [
          this.$HMValidator.money('面积', 8, 2)
        ],
        gd: [
          this.$HMValidator.money('高度', 8, 2)
        ],
        dxcs: [
          this.$validUtils.required('地下层层数'),
          this.$HMValidator.number('地下层层数'),
          this.$validUtils.maxLengthValid('地上层层数', 2)
        ],
        dscs: [
          this.$validUtils.required('地上层层数'),
          this.$HMValidator.number('地上层层数'),
          this.$validUtils.maxLengthValid('地上层层数', 3),
          this.$validUtils.maxNumberValid('地上层层数')
        ]
      },
      /* 表单校验规则 End */

      dlType: 'add' // 模态框类型，'add': 新增，'edit': 修改

    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '建筑信息编辑' : '建筑信息新增'}`;
    }
  },
  methods: {

    /**
     * @description: 初始化建筑物信息
     * @return {*}
     */
    async init () {
      this.loading = true;
      await jzwService.getJzwInfo(this.dlParams.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('获取建筑物信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.dlType === 'add') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      jzwService.saveJzw(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave () {
      jzwService.updateJzw(this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.fd.xmId = this.$route.params.xmId;
    console.log(this.$route.params.xmId);
    if (this.dlParams.id) {
      this.dlType = 'edit';
      this.editShow = (this.dlType === 'edit');
      this.init();
    }
  }
};
</script>
